export function makeSampleGeolocation() {
  return { latitude: 0, longitude: 0, meanSeaLevel: 0 };
}
